import {
  BaseButtonComponent,
  BaseCheckboxComponent,
  BaseDatepickerComponent,
  BaseDropdownComponent,
  BaseInputComponent,
  BaseLabelComponent,
  BaseMultiselectComponent,
  BaseRadioComponent,
  BaseTextareaComponent,
} from '@d-components';
import { CONTROL_TYPE } from '@d-components/form/form.interface';

export const allBaseUIForm = {
  [CONTROL_TYPE.Textbox]: BaseInputComponent,
  [CONTROL_TYPE.Textarea]: BaseTextareaComponent,
  [CONTROL_TYPE.Dropdown]: BaseDropdownComponent,
  [CONTROL_TYPE.Calendar]: BaseDatepickerComponent,
  [CONTROL_TYPE.Checkbox]: BaseCheckboxComponent,
  [CONTROL_TYPE.Radio]: BaseRadioComponent,
  [CONTROL_TYPE.Multiselect]: BaseMultiselectComponent,
  [CONTROL_TYPE.Label]: BaseLabelComponent,
  [CONTROL_TYPE.Button]: BaseButtonComponent,
};
